import styled from 'styled-components';

export default styled.textarea`
  display: block;
  width: 100%;
  border: ${props => props.error ? '1px solid rgba(255, 98, 86, 1)' : '1px solid rgba(225, 227, 244, 1)'};
  background: ${props => props.readOnly ? 'rgba(0, 0, 0, 0.2)' : props => props.disabled ? 'rgb(229, 232, 241)' : 'transparent'};
  height: 22.5rem;
  border-radius: 0.2rem;
  padding: 1rem;
  color:  ${props => props.error 
    ? 'rgba(255, 98, 86, 1)' 
    : props.disabled ? 'rgba(198, 202, 219, 1)' : 'rgba(39, 39, 39, 1)'};
  line-height: 2rem;
  font-size: 1.4rem;
  cursor: ${props => props.isEditable ? 'pointer' : props => props.disabled || props.readOnly ? 'default' : 'text'};

  &:focus {
    border: ${props => props.noFocus && typeof props.noFocus === 'string' ? props.noFocus : props.noFocus || props.readOnly || props.disabled ? '0 solid rgba(225, 227, 244, 1)' : '1px solid rgba(111, 88, 255, 1)'};
    caret-color: ${props => props.noCaret ? 'transparent' : 'inherit'};
    ${props => props.thisStyles 
      ? `
        ${props.thisStyles}
        border-width: 2px;
      ` 
      : 'rgba(111, 88, 255, 1);'}
    ${ props => props.noFocus ? 'outline: none;' : ''}
  }


  ${props => props.thisStyles}

`;
